/* ==========================================================================
   WEAR THE DRESS — THEME JS
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- MOBILE MENU ---------- */
  var menuBtn = document.getElementById('mobileMenuBtn');
  var menuClose = document.getElementById('mobileNavClose');
  var mobileNav = document.getElementById('mobileNav');
  var overlay = document.getElementById('mobileOverlay');

  function openMenu(){
    if(mobileNav){ mobileNav.classList.add('active'); }
    if(overlay){ overlay.classList.add('active'); }
    if(menuBtn){ menuBtn.setAttribute('aria-expanded','true'); }
    document.body.style.overflow = 'hidden';
  }
  function closeMenu(){
    if(mobileNav){ mobileNav.classList.remove('active'); }
    if(overlay){ overlay.classList.remove('active'); }
    if(menuBtn){ menuBtn.setAttribute('aria-expanded','false'); }
    document.body.style.overflow = '';
  }
  if(menuBtn) menuBtn.addEventListener('click', openMenu);
  if(menuClose) menuClose.addEventListener('click', closeMenu);
  if(overlay) overlay.addEventListener('click', closeMenu);

  /* ---------- BACK TO TOP ---------- */
  var backToTop = document.getElementById('backToTop');
  if(backToTop){
    window.addEventListener('scroll', function(){
      if(window.scrollY > 500){ backToTop.classList.add('show'); }
      else { backToTop.classList.remove('show'); }
    });
    backToTop.addEventListener('click', function(){
      window.scrollTo({top:0, behavior:'smooth'});
    });
  }

  /* ---------- COOKIE BANNER (RGPD) ---------- */
  var cookieBanner = document.getElementById('cookieBanner');
  var cookieAccept = document.getElementById('cookieAccept');
  var cookieDecline = document.getElementById('cookieDecline');
  var COOKIE_KEY = 'wtd_cookie_consent';

  function getConsent(){
    try { return localStorage.getItem(COOKIE_KEY); } catch(e){ return null; }
  }
  function setConsent(val){
    try { localStorage.setItem(COOKIE_KEY, val); } catch(e){}
  }
  if(cookieBanner && !getConsent()){
    cookieBanner.classList.add('show');
  }
  if(cookieAccept){
    cookieAccept.addEventListener('click', function(){
      setConsent('accepted');
      cookieBanner.classList.remove('show');
    });
  }
  if(cookieDecline){
    cookieDecline.addEventListener('click', function(){
      setConsent('declined');
      cookieBanner.classList.remove('show');
    });
  }

  /* ---------- PRODUCT GALLERY THUMBS ---------- */
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.getElementById('ProductMainImage');
  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      thumbs.forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
      if(mainImg && thumb.dataset.full){
        mainImg.src = thumb.dataset.full;
      }
    });
  });

  /* ---------- PRODUCT OPTION SELECTORS (size / color) ---------- */
  var optionBtns = document.querySelectorAll('.size-btn, .color-option');
  var variantSelect = document.getElementById('VariantSelect');

  // Build a map of option values per variant from the hidden select
  function getSelectedOptions(){
    var selected = {};
    document.querySelectorAll('.size-btn[aria-checked="true"], .color-option[aria-checked="true"], .option-select').forEach(function(el){
      var idx = el.dataset ? el.dataset.optionIndex : null;
      if(el.tagName === 'SELECT'){
        idx = el.dataset.optionIndex;
        selected[idx] = el.value;
      } else if(idx !== undefined){
        selected[idx] = el.dataset.value;
      }
    });
    return selected;
  }

  function updateVariant(){
    if(!variantSelect) return;
    var selected = getSelectedOptions();
    var options = variantSelect.querySelectorAll('option');
    options.forEach(function(opt){
      var title = opt.textContent.split(' - ')[0].trim();
      var parts = title.split(' / ');
      var match = true;
      Object.keys(selected).forEach(function(idx){
        if(parts[idx] && parts[idx].trim() !== selected[idx]){ match = false; }
      });
      if(match && !opt.disabled){
        opt.selected = true;
        var price = opt.textContent.split(' - ')[1];
        var addBtn = document.getElementById('AddToCartBtn');
        if(addBtn && price){
          addBtn.textContent = 'Ajouter au panier — ' + price;
        }
      }
    });
  }

  optionBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var group = btn.classList.contains('size-btn') ? '.size-btn' : '.color-option';
      var idx = btn.dataset.optionIndex;
      document.querySelectorAll(group + '[data-option-index="' + idx + '"]').forEach(function(b){
        b.setAttribute('aria-checked','false');
      });
      btn.setAttribute('aria-checked','true');
      var label = document.getElementById('SelectedValue-' + idx);
      if(label) label.textContent = btn.dataset.value;
      updateVariant();
    });
  });

  document.querySelectorAll('.option-select').forEach(function(sel){
    sel.addEventListener('change', updateVariant);
  });

  /* ---------- QUANTITY SELECTORS ---------- */
  document.querySelectorAll('.qty-minus').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = btn.nextElementSibling;
      var val = parseInt(input.value, 10) || 1;
      if(val > (parseInt(input.min,10) || 0)){ input.value = val - 1; }
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
  });
  document.querySelectorAll('.qty-plus').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = btn.previousElementSibling;
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
  });

  /* ---------- PRODUCT TABS ---------- */
  var tabBtns = document.querySelectorAll('.tab-btn');
  tabBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var target = btn.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function(b){ b.classList.remove('active'); });
      document.querySelectorAll('.tab-content').forEach(function(c){ c.classList.remove('active'); });
      btn.classList.add('active');
      var content = document.querySelector('.tab-content[data-tab-content="' + target + '"]');
      if(content) content.classList.add('active');
    });
  });

  /* ---------- CART LINE QUANTITY (cart page) ---------- */
  document.querySelectorAll('.cart-item .qty-minus, .cart-item .qty-plus').forEach(function(btn){
    btn.addEventListener('click', function(){
      var form = btn.closest('form');
      if(form){
        setTimeout(function(){ form.submit(); }, 50);
      }
    });
  });

  document.querySelectorAll('.cart-item-remove').forEach(function(btn){
    btn.addEventListener('click', function(){
      var line = btn.dataset.line;
      var qtyInput = document.querySelector('.qty-input[data-line="' + line + '"]');
      if(qtyInput){
        qtyInput.value = 0;
        var form = btn.closest('form');
        if(form) form.submit();
      }
    });
  });

  /* ---------- HEADER SCROLL SHADOW ---------- */
  var header = document.querySelector('.site-header');
  if(header){
    window.addEventListener('scroll', function(){
      if(window.scrollY > 10){ header.style.boxShadow = '0 4px 20px rgba(0,0,0,.06)'; }
      else { header.style.boxShadow = 'none'; }
    });
  }

});
